var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-container"},[_c('van-nav-bar',{attrs:{"left-arrow":"","fixed":"","z-index":10,"title":_vm.protocol.title},on:{"click-left":function($event){return _vm.goableBack()}}}),_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.protocol.content)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }